import { Component } from '@angular/core';
import { IonicPage, NavParams } from 'ionic-angular';
import { NavController, ModalController, AlertController } from 'ionic-angular';
import * as moment from 'moment';

import { VariablesProvider } from '../../providers/variables/variables';
import { FuncionesProvider } from '../../providers/funciones/funciones';
import { PicajesPage } from '../../pages/picajes/picajes';

import { CalendarioPage } from '../../pages/calendario/calendario';
import { LoginPage } from '../../pages/login/login';
import { CalendarModal, CalendarModalOptions, DayConfig, CalendarResult } from "ion2-calendar";
import { CalendarComponentOptions } from 'ion2-calendar'
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { ListPage } from '../list/list';
import { ZonaObraPage } from '../zona-obra/zona-obra';

/**
 * Generated class for the ObrasPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-obras',
  templateUrl: 'obras.html',
})
export class ObrasPage {

  diasdefiesta;
  myForm: FormGroup;
  myForm1: FormGroup;
  myForm2: FormGroup;
  misapp: Array<{title: string, descripcion: string, imagen: string , component: any}>;
  formulario = {codigo1: "",nombre1: "",empresa1: "" ,turno1: "" ,activo1: ""}
  resultado;
  date: string;
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  minuto = []; //= {valor: "1",color: "1"}
  color = []; //= {valor: "1",color: "1"}
  cabecera = []; //= {valor: "1",color: "1"}
  obras;
  valo="654321123456" ;
  formulario2 = {valor: ""}
  obrasKeys;
  values:Array<string> = [];
  empresas;
  turnos;


  
  constructor(
  	public navParams: NavParams,
    public fb: FormBuilder,
    private alertCtrl: AlertController,
    public modalCtrl: ModalController,
  	public navCtrl: NavController,
    public funciones:FuncionesProvider,
  	public variables:VariablesProvider
    ) {                    
            
      this.variables.btatras = true;
      var sum = 0;
      var horas=0;
  
      this.myForm = this.fb.group({

      id: [''],
      nombre: ['' ],
      empresa:[''],
      turno:[''],
      activo: ['' ],
          
     
     });

      this.myForm1 = this.fb.group({

      id1: ['', [Validators.required]],
      nombre1: ['', [Validators.required]],
      empresa1: ['', [Validators.required]],
      turno1: ['', [Validators.required]],
      activo1: ['', [Validators.required]],

     });
   

    this.obtenerobras(this.valo);

  }

   buscarobras(){
     var neutro;
    if (this.formulario2.valor != ""){
      neutro = this.formulario2.valor;
     }else{
      neutro = this.valo;
    }
    //console.log("Vamos a buscar :" + neutro);
    this.funciones.obtieneobras(neutro).then(
          data => {
          this.obras = data;



          //console.log("Aqui estaaa");
          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }

  obtenerobras(filtro){

    this.funciones.obtieneobras(filtro).then(
          data => {

          this.obras = data;


          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }

   editarobras(index){

     //console.log(this.obras[index].ID);
     //console.log(this.obras[index].NOMBRE);
     //console.log(this.obras[index].ACTIVO);
     if (this.obras[index].EMPRESA=="") {
       this.obras[index].EMPRESA="654321123456";
     }
     if (this.obras[index].TURNO=="") {
       this.obras[index].TURNO="654321123456";
     }

    this.funciones.editarobras(this.obras[index].ID,this.obras[index].NOMBRE,this.obras[index].ACTIVO).then(
          data => {
            //console.log(data);
            this.obras = data;
            this.obtenerobras(this.valo);
          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
     
  }

  registro(){

     if (this.formulario.activo1=='') {
       this.formulario.activo1 = "NO";
     }

 if (this.formulario.empresa1=="") {
       this.formulario.empresa1="654321123456";
     }
     if (this.formulario.turno1=="") {
       this.formulario.turno1="654321123456";
     }

   //console.log(this.formulario.nombre1);
   //console.log(this.formulario.empresa1);
   //console.log(this.formulario.turno1);
   //console.log(this.formulario.activo1);

   this.funciones.grabarobras(this.formulario.nombre1,this.formulario.activo1).then(
     data => {
          this.resultado = data;


          this.obtenerobras(this.valo);

           this.formulario.nombre1="";

           
        })


  }


      obtenerempresas(filtro){

    this.funciones.obtieneempresas(filtro).then(
          data => {

          this.empresas = data;
          //console.log("Las empresas:" + this.empresas);


          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }

 

    obtenerturnos(filtro){

    this.funciones.obtieneturnos(filtro).then(
          data => {

          this.turnos = data;
          //console.log("Los turnos:" + this.turnos);


          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }


   borrar(codigo,nombre){

   

      let alert = this.alertCtrl.create({
          title: 'Borrar.',
          message: '¿Confirma borrar la obra? '  + codigo + ' -> ' + nombre,
          cssClass: 'alertCustomCss',
          buttons: [{
              text: 'No',
              role: 'No',
              handler: () => {  }
            },{
              text: 'Si',
              handler: () => {


               this.funciones.delobras(codigo).then(
                   data => {
                    
                    this.obtenerobras(this.valo);

                  })           
              }
            }
          ]
        });
        alert.present();
     
  }

ponencampo(campo:string, value:string):void{
      
      switch (campo) {
         case "EMPRESA":
           this.formulario.empresa1 = value;
           break;
         case "TURNO":
           this.formulario.turno1 = value;
           break;
         case "ACTIVO":
           this.formulario.activo1 = value;
           break;
         
         default:
           // code...
           break;
       }
     
    }
 

  salir(){
      this.navCtrl.push(ListPage);
   }

   configurarZona(obra: any){
      this.navCtrl.push(ZonaObraPage, { obra: obra, obras: this.obras });
   }
 valChange(campo:string, value:string, index:number):void{
      
      //alert("Campo->" + campo + "valor->" + value + "lugar->" + index)

      switch (campo) {
         case "ID":
           this.obras[index].ID = value;
           break;
         case "NOMBRE":
           this.obras[index].NOMBRE = value;
           break;
         case "EMPRESA":
           this.obras[index].EMPRESA = value;
           break;
         case "TURNO":
           this.obras[index].TURNO = value;
           break;
          case "ACTIVO":
           this.obras[index].ACTIVO = value;
           break;
       
         
         default:
           // code...
           break;
       }
     
    }


}



// WEBPACK FOOTER //
// ./src/pages/obras/obras.ts